/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */

import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../../../../services/auth.service';
import { AppState, AppStateUser } from '../../../../services/app-state.service';

@Component({
	selector: 'who-you',
	templateUrl: './who-you.component.html',
	styleUrls: ['./who-you.component.scss'],
})
export class WhoYouComponent {
	public whoYou$: Observable<string> = this.appState.user.pipe(
		map((user: AppStateUser) => (user && user.morphedUser ? user.email : null))
	);

	public signOut(): void {
		this.authService.logout();
	}

	constructor(private appState: AppState, private authService: AuthService) {}
}
